import React from "react";
import { Typography } from "@mui/material";
import styled from "styled-components";
import { Pane } from "../Pane";

interface Props {
  message: string;
  children?: React.ReactNode;
}

export function PaneLoader(props: Props) {
  return (
    <StyledPane>
      <Typography variant="h2" component="h1">
        {props.message}
      </Typography>
      {props.children}
    </StyledPane>
  );
}

const StyledPane = styled(Pane)``;
